// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_1lDIt","selectWrapper":"_3VCB2"};